import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=41ea67b0&"
import script from "./Purchased.vue?vue&type=script&lang=js&"
export * from "./Purchased.vue?vue&type=script&lang=js&"
import style0 from "./Purchased.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ea67b0')) {
      api.createRecord('41ea67b0', component.options)
    } else {
      api.reload('41ea67b0', component.options)
    }
    module.hot.accept("./Purchased.vue?vue&type=template&id=41ea67b0&", function () {
      api.rerender('41ea67b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Purchased.vue"
export default component.exports